<mat-accordion multi="true">
    <h3 *ngIf="title" class="mibi-title">{{title}}</h3>
    <mat-expansion-panel *ngFor="let entry of entries">
        <mat-expansion-panel-header collapsedHeight="auto" expandedHeight="auto">
            <mat-panel-title>
                <div class="mibi-panel-title"><markdown [data]="entry.question" [inline]="true"></markdown></div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            <div class="mibi-panel-text" (click)="onAnswerClick($event)">
                <markdown [data]="entry.answer"></markdown>
            </div>
        </ng-template>
    </mat-expansion-panel>
</mat-accordion>
